
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getCosumerLogList,
  delCosumerLog,
  batchReconsumeCosumerLog,
  reconsumeCosumerLog
} from "@/api/oms-operation-service";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class KafkaLog extends Vue {
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    startTime: "",
    endTime: "",
    endOffset: "",
    startOffset: "",
    partition: "",
    topic: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private selectList: object[] = [];
  private ruleInline = {};
  private time: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("kafkaLog.topic"),
      key: "topic",
      minWidth: 80
    },
    {
      title: i18n.t("kafkaLog.topicInfo"),
      key: "topicInfo",
      minWidth: 120
    },
    {
      title: i18n.t("kafkaLog.partition"),
      key: "partition",
      minWidth: 120
    },
    {
      title: "offset",
      key: "offset",
      width: 120
    },
    {
      title: i18n.t("kafkaLog.requestParam"),
      key: "requestParam",
      minWidth: 180
    },
    {
      title: i18n.t("kafkaLog.reason"),
      key: "reason",
      minWidth: 120
    },
    {
      title: i18n.t("kafkaLog.createTime"),
      key: "createTime",
      width: 180
    },
    {
      title: i18n.t("operation"),
      key: "action",
      width: 120,
      slot: "action"
    }
  ];

  public selectItem(list: object[]) {
    this.selectList = list;
  }
  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    // this.getTableList();
  }
  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.startTime = this.$common.userDate(val[0]).split(" ")[0];
      this.formInline.endTime = this.$common.userDate(val[1]).split(" ")[0];
    } else {
      this.formInline.startTime = "";
      this.formInline.endTime = "";
    }
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getCosumerLogList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
    this.selectList = [];
  }
  public delItem(item: objAny) {
    this.delSub([item.pkid]);
  }
  public allUpClick() {
    const arr: string[] = [];
    this.selectList.map((item: objAny) => {
      arr.push(item.pkid);
    });
    this.upSub(arr);
  }
  public delClick() {
    const arr: string[] = [];
    this.selectList.map((item: objAny) => {
      arr.push(item.pkid);
    });
    this.delSub(arr);
  }
  async delSub(list: string[]) {
    const ret = await delCosumerLog({
      list: list
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }
  async upClick(item: objAny) {
    const ret = await reconsumeCosumerLog({
      pkid: item.pkid,
      requestParam: item.requestParam
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }
  async upSub(list: string[]) {
    const ret = await batchReconsumeCosumerLog({
      list: list
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }

  mounted() {
    const time = this.$common.thisTimes("yyyy-MM-dd");
    this.time = [time, time];
    this.formInline.startTime = time;
    this.formInline.endTime = time;
    this.getTableList();
  }
}
